import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=476692d2&scoped=true&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"
import style0 from "./validate.vue?vue&type=style&index=0&id=476692d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476692d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476692d2')) {
      api.createRecord('476692d2', component.options)
    } else {
      api.reload('476692d2', component.options)
    }
    module.hot.accept("./validate.vue?vue&type=template&id=476692d2&scoped=true&", function () {
      api.rerender('476692d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/validate.vue"
export default component.exports